(function () {
    'use strict';

    angular.module("imApp").factory("deviationTypeLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listDeviationTypeLanguages: function (parms) {
                return $ihttp.post({
                    method: 1232,
                    parameters: parms || {}
                });
            },
            saveObj: function (languages) {
                return $ihttp.post({
                    method: 1233,
                    parameters: languages
                });
            }
        };

        return service;
    }]);
})();
